import { useState } from "react";
import { Link } from "react-router-dom";
import { API } from "@/App";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shield, Mail, Loader2, ArrowLeft, Check } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const AdminForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/forgot-password`, { email });
      setSent(true);
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="admin-forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-violet-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-violet-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Admin Password Reset</h1>
          <p className="text-slate-400 mt-2">Enter your admin email</p>
        </div>

        <Card className="card-dashboard">
          <CardContent className="p-6">
            {sent ? (
              <div className="text-center py-4">
                <div className="w-12 h-12 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Check className="w-6 h-6 text-emerald-400" />
                </div>
                <h3 className="text-white font-semibold text-lg mb-2">Check Your Email</h3>
                <p className="text-slate-400 text-sm mb-6">
                  If an admin account exists for <strong className="text-white">{email}</strong>, you'll receive a reset link.
                </p>
                <Link to="/admin/login">
                  <Button className="bg-violet-600 hover:bg-violet-700 text-white w-full">
                    <ArrowLeft className="w-4 h-4 mr-2" />Back to Admin Login
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label className="text-slate-300">Admin Email</Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
                    <Input
                      type="email"
                      placeholder="admin@company.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="pl-10 input-default"
                      required
                      data-testid="admin-forgot-email-input"
                    />
                  </div>
                </div>
                <Button type="submit" className="bg-violet-600 hover:bg-violet-700 text-white w-full h-11" disabled={loading} data-testid="admin-forgot-submit-btn">
                  {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Sending...</> : "Send Reset Link"}
                </Button>
                <div className="text-center">
                  <Link to="/admin/login" className="text-sm text-violet-400 hover:text-violet-300">
                    <ArrowLeft className="w-3 h-3 inline mr-1" />Back to Admin Login
                  </Link>
                </div>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;
